import connectMeStore from 'core/controllerConnectMe/connectMeStore'
import clickEventName from 'utils/DOM/clickEventName'
import textContent from 'utils/DOM/textContent'
import storage from 'proxy-storage'
import store from 'utils/store/withMiddleware'
import gapContactPage from '../gapContactPage/gapContactPage'

const parentDiv = $('#gap-step')
const $body = $('body')

function goToStep2(e) {
  e.preventDefault()

  parentDiv.find('.gap-page-step1').removeClass('active')
  parentDiv.find('.gap-page-step2').addClass('active')
}

export default function(experience) {
  const connectMeState = connectMeStore.getState()
  connectMeState.modules['step-gap-page'].idLocation = experience
  connectMeStore.update(connectMeState)

  const hcData = storage.getItem('hc')
  textContent('.js-applicant-name', hcData.contact.first_name)
  textContent('.js-location-state', hcData.location.state)

  const state = store.getState()
  gapContactPage(state)
  store.registry(gapContactPage)

  $body.on(clickEventName, '.step-1-button', goToStep2)
}
